module.exports = __webpack_public_path__ + "media/images/flags/cu-9ead3c2be0a5d8600b8d1d3fa462ac71.svg";